
/*
  Tobias.ouwejan
*/

PHI.favorite = {
  favorites: [],

  bindFavorites: function() {
    $('.add-to-favorites').on('click', this.addToFavorites.bind(this));
  },


  addToFavorites: function(evnt) {
    var form = $(evnt.target).parent();

    form.attr('action', form.attr('favorites-add-action'));
  },

  setAddToCartAction: function() {
    var productCode = '';
    var qtyField = '';

    $('.addToCartButton').click(function() {
      $('.add_to_cart_form').attr('action', $('.add_to_cart_form').attr('cart-action'));

      productCode = $(this).val();
      qtyField = $('.favQty-' + productCode).val();

      /* eslint-disable no-undefined */
      if (qtyField !== null && qtyField !== '' && qtyField !== undefined && qtyField > 0) {
        /* eslint-enable no-undefined */
        $(this).next().next().next().find('.loader').show();
        $(this).next().next().next().find('.wait-message').show();
        $('#detail-loader').show();
        $('#detail-wait-message').show();
        $('.hide_add_to_cart').show();
        $('.ph-pdp-addtocart-popup').addClass('ph-disable-button');
      }
    });
  }

};

$(function() {
  PHI.favorite.bindFavorites();

  PHI.favorite.setAddToCartAction();
});
